import Form from 'react-bootstrap/Form';
import _pull from 'lodash/pull';
import _get from 'lodash/get';

const FormField = (props) => {

  const {id, label, type = "text", formikBag, onChange = ()=>{}, formatValue, options, inline, hasValidation, text, ...rest} = props;
  const {values, errors, touched, submitCount, setFieldValue, setFieldTouched} = formikBag;

  // allow errors to be a string or array
  let errMsg = "";
  if (errors[id]) {
    if (typeof errors[id] === 'string') {
      errMsg = errors[id];
    } else if (Array.isArray(errors[id])) {
      errMsg = errors[id][0];
    }
  }

  let fieldVal = _get(values, id);
  
  let isTouched = Boolean(touched[id]);
  if (id.indexOf(".") > 0) {
    // this makes some assumptions about where field arrays are used
    let idArr = id.split(".");
    if (touched[idArr[0]] && touched[idArr[0]][parseInt(idArr[1])]) {
      isTouched = true;
    }
  }
  let isValid = Boolean(hasValidation && !errors[id] && isTouched);
  let isInvalid = Boolean(errors[id] && (isTouched || submitCount > 0));

  if (type === "radios") {
    return (
      <Form.Group className="form-group">
        {label}
        {options.map((opt, i) => {
          return (
            <Form.Check
              key={i}
              inline={inline}
            >
              <Form.Check.Label>
                <Form.Check.Input
                  type="radio"
                  name={id}
                  value={opt.value}
                  checked={opt.value === fieldVal}
                  isInvalid={isInvalid}
                  isValid={isValid}
                  onBlur={() => { setFieldTouched(id); }}
                  onChange={(e) => {
                    let v = e.target.value;
                    console.log("radios onChange", v);
                    if (typeof formatValue === 'function') {
                      v = formatValue(v);
                    }
                    setFieldValue(id, v);
                    onChange(v);
                  }}
                  {...rest}
                />
                {opt.label}
              </Form.Check.Label>
            </Form.Check>
          );
        })}
        {text && <Form.Text>{text}</Form.Text>}
        {errMsg && isInvalid && <Form.Text className="text-danger">{errMsg}</Form.Text>}
      </Form.Group>
    );
  }

  if (type === "checkboxes") {
    return (
      <Form.Group className="form-group">
        {label}
        {options.map((opt, i) => {
          let value = fieldVal;
          let isChecked = value && value.indexOf(opt.value) > -1;
          return (
            <Form.Check
              key={i}
              inline={inline}
            >
              <Form.Check.Label>
                <Form.Check.Input
                  type="checkbox"
                  name={id}
                  value={opt.value}
                  checked={isChecked}
                  isInvalid={isInvalid}
                  isValid={isValid}
                  onBlur={() => { setFieldTouched(id); }}
                  onChange={(e) => {
                    let newValue = [...value];
                    if (isChecked) {
                      _pull(newValue, opt.value);
                    } else {
                      newValue.push(opt.value);
                    }
                    setFieldValue(id, newValue);
                    onChange(newValue);
                  }}
                  {...rest}
                />
                {opt.label}
              </Form.Check.Label>
            </Form.Check>
          );
        })}
        {text && <Form.Text>{text}</Form.Text>}
        {errMsg && isInvalid && <Form.Text className="text-danger">{errMsg}</Form.Text>}
      </Form.Group>
    );
  }

  if (type === "checkbox" || type === "radio" || type === "switch") {
    return (
      <Form.Check
        id={id}
        type={type}
        checked={!!fieldVal}
        label={label}
        onBlur={() => { setFieldTouched(id); }}
        onChange={(e) => {
          let v = !fieldVal;
          setFieldValue(id, v);
          onChange(v);
        }}
        feedback={errMsg}
        isInvalid={isInvalid}
        isValid={isValid}
        inline={inline}
        {...rest}
      />
    );
  }

  if (type === "select") {
    return (
      <Form.Group className="form-group" controlId={id}>
        <Form.Label>{label}</Form.Label>
        <Form.Select
          as={type}
          value={fieldVal || ""}
          onBlur={() => { setFieldTouched(id); }}
          onChange={(e) => {
            let v = e.target.value;
            if (typeof formatValue === 'function') {
              v = formatValue(v);
            }
            setFieldValue(id, v);
            onChange(v);
          }}
          isInvalid={isInvalid}
          isValid={isValid}
          {...rest}
        >
          {options.map((opt, i) => {
              if (typeof opt === "string") {
                  return (<option value={opt} key={i}>{opt}</option>);
              }
              return (<option value={opt.value} key={i}>{opt.label}</option>);
          })}
        </Form.Select>
        {text && <Form.Text>{text}</Form.Text>}
        {errMsg && isInvalid && <Form.Text className="text-danger">{errMsg}</Form.Text>}
      </Form.Group>
    );
  }

  if (type === "textarea") {
    return (
      <Form.Group className="form-group" controlId={id}>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          as={type}
          value={fieldVal || ""}
          onBlur={() => { setFieldTouched(id); }}
          onChange={(e) => {
            let v = e.target.value;
            if (typeof formatValue === 'function') {
              v = formatValue(v);
            }
            setFieldValue(id, v);
            onChange(v);
          }}
          isInvalid={isInvalid}
          isValid={isValid}
          {...rest}
        />
        {text && <Form.Text>{text}</Form.Text>}
        {errMsg && isInvalid && <Form.Text className="text-danger">{errMsg}</Form.Text>}
      </Form.Group>
    );
  }

  return (
    <Form.Group className="form-group" controlId={id}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type={type}
        value={fieldVal || ""}
        onBlur={() => { setFieldTouched(id); }}
        onChange={(e) => {
          let v = e.target.value;
          if (typeof formatValue === 'function') {
            v = formatValue(v);
          }
          setFieldValue(id, v);
          onChange(v);
        }}
        isInvalid={isInvalid}
        isValid={isValid}
        {...rest}
      />
      {text && <Form.Text>{text}</Form.Text>}
      {errMsg && isInvalid && <Form.Text className="text-danger">{errMsg}</Form.Text>}
    </Form.Group>
  );
}

// FormField.propTypes = {
//   id: PropTypes.string.isRequired,
//   formikBag: PropTypes.object.isRequired,
//   label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
//   type: PropTypes.oneOf(["text", "textarea", "select", "checkbox", "radio", "switch", "checkboxes", "radios", "password"]),
//   onChange: PropTypes.func,
//   formatValue: PropTypes.func,
//   options: PropTypes.array,
//   inline: PropTypes.bool,
//   hasValidation: PropTypes.bool
// };
// 
// FormField.defaultProps = {
//   type: "text",
//   onChange: () => {},
// }

export default FormField;
